module.exports = __webpack_public_path__ + "d71d8ccb7264fb1ca4a4ec9a871849d1.gif";